{
  "process-container": {
    "text": {
      "back-to-home": "Retour à la page d'accueil",
      "page-loading": "La page se charge"
    }
  }
}
